<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-py-10">
            <svg id="_005-check-2" data-name="005-check-2" xmlns="http://www.w3.org/2000/svg" width="60" height="43.659" viewBox="0 0 60 43.659">
                <path id="Path_32" data-name="Path 32" d="M58.242,65.438,26.59,97.088a6.006,6.006,0,0,1-8.492,0L1.758,80.748a6,6,0,0,1,8.491-8.493l12.1,12.1,27.4-27.4a6.005,6.005,0,0,1,8.493,8.492Z" transform="translate(0 -55.188)" fill="#c6003e"/>
            </svg>
            <h3>Pedido de informações enviado</h3>
            <small class="tw-texr-sm tw-px-4 lg:tw-px-0 lg:tw-text-xl tw-text-black tw-block tw-font-bold tw-pb-5">A Minisom irá contactar em breve com mais informações <br class="tw-hidden lg:tw-block">sobre a consulta gratuita</small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import "~@/assets/scss/partials/_variables.scss";

.form-success {

    svg {
        @apply tw-block tw-mx-auto tw-w-fit;
    }

    h3 {
        @apply tw-font-bold tw-text-center tw-mt-10 tw-mb-6 tw-text-2xl;
        color: $main_color;

        @screen lg {
            @apply tw-text-3xl
        }
    }
}

</style>
